import ScrollMagic from 'scrollmagic';
import { TweenLite, TimelineMax } from 'gsap';
import { ScrollMagicPluginGsap } from "scrollmagic-plugin-gsap";
ScrollMagicPluginGsap(ScrollMagic, TweenLite, TimelineMax);

const $ = window.jQuery;
const $window = window.$window || $(window);


const Projects = {


  init () {
    var $projects = $('.project-summary');
    if (!$projects.length)
        return;
    
    $projects.each(function(){
      var $this = $(this);
      //console.log($('.summary-wrapper').height());
      
      $this.find('.toggle-button').on('click', function(){
        
        if($this.hasClass('active')){
          $this.removeClass('active');
          $this.css('height', '200px');
        }else{
          $projects.removeClass('active');
        $projects.css('height', '200px');
          $this.css('height', $('.summary-wrapper').height()+160);
          $this.addClass('active');

        }
        if($window.width() < 768){
          setTimeout(function(){
            var pos = $this.position();
            $("html, body").animate({ scrollTop: pos.top - 107 });
          },600);
        }
      })
    })

  }
};

export default Projects;